/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSamplingDataForRunEntry } from '../../models/create-sampling-data-for-run-entry';

export interface CreateSamplingDataForRun$Params {
  workCenterId: number;
  runId: number;
      body: CreateSamplingDataForRunEntry
}

export function createSamplingDataForRun(http: HttpClient, rootUrl: string, params: CreateSamplingDataForRun$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createSamplingDataForRun.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('runId', params.runId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createSamplingDataForRun.PATH = '/api/v1/QaCheck/{workCenterId}/CreateSamplingDataForRun/{runId}';
